import React, { useState, useEffect } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { getKurum } from '../services/api';
import kelebek from '../assets/kelebek.png';

const TUM_MENU = [
  { yol: '/',            ikon: '🏠', etiket: 'Panel',          bitti: true,  yetk: null },
  { yol: '/hastalar',    ikon: '🧑‍🤝‍🧑', etiket: 'Hastalar',        yetk: 'yetk3'  },
  { yol: '/randevular',  ikon: '📅', etiket: 'Randevuları Gör', yetk: 'yetk19' },
  { yol: '/randevu-ver', ikon: '✏️', etiket: 'Randevu Ver',     yetk: 'yetk4'  },
  { yol: '/muayeneler',  ikon: '🩺', etiket: 'Muayeneler',      yetk: 'yetk6'  },
  { yol: '/faturalar',   ikon: '📄', etiket: 'Faturalar',       yetk: 'yetk7'  },
  { yol: '/tahsilatlar', ikon: '💰', etiket: 'Tahsilatlar',     yetk: 'yetk44' },
  { yol: '/harcamalar',  ikon: '💸', etiket: 'Harcamalar',      yetk: 'yetk20' },
  { yol: '/odemeler',    ikon: '🏦', etiket: 'Ödemeler',        yetk: 'yetk46' },
  { yol: '/kasa',        ikon: '💳', etiket: 'Kasa',            yetk: 'yetk8'  },
  { yol: '/sifremi-degistir', ikon: '🔑', etiket: 'Şifremi Değiştir', yetk: null },
];

const mobilMi = () => typeof window !== 'undefined' && window.innerWidth <= 820;

export default function Layout() {
  const navigate = useNavigate();
  const kullanici = JSON.parse(localStorage.getItem('kullanici') || '{}');
  const adSoyad = kullanici.adSoyad || 'Kullanıcı';

  // Hiç YETK tanımlanmamışsa (hepsi 0/null) → tüm menüyü göster
  const yetkilendirilmis = TUM_MENU.some(m => m.yetk !== null && kullanici[m.yetk] === 1);
  const menu = TUM_MENU.filter(m =>
    m.yetk === null || !yetkilendirilmis || kullanici[m.yetk] === 1
  );
  const basharf = adSoyad.trim().charAt(0).toUpperCase();

  // PC'de açık, mobilde kapalı başlasın
  const [acik, setAcik] = useState(!mobilMi());

  // Kurum adı (FRM_TAN.FRM_AD) — üst başlıkta gösterilir
  const [kurumAdi, setKurumAdi] = useState('Klinik Yönetim Sistemi');
  useEffect(() => {
    getKurum()
      .then(res => { if (res.data && res.data.ad) { setKurumAdi(res.data.ad); document.title = res.data.ad; } })
      .catch(() => {});
  }, []);

  // Ekran boyutu değişince mobile/masaüstü varsayılanına uy
  useEffect(() => {
    const f = () => setAcik(!mobilMi());
    window.addEventListener('resize', f);
    return () => window.removeEventListener('resize', f);
  }, []);

  const cikis = () => {
    localStorage.removeItem('kullanici');
    window.close();
  };

  // Mobilde bir menüye tıklanınca paneli kapat
  const menuTikla = () => { if (mobilMi()) setAcik(false); };

  return (
    <div className="app">
      {/* Mobilde panel açıkken arka plan karartması */}
      <div className={'backdrop' + (acik ? ' gorunur' : '')} onClick={() => setAcik(false)} />

      <aside className={'yan-menu' + (acik ? '' : ' kapali')}>
        <div className="yan-logo">
          <img src={kelebek} alt="Dr.Plazma" width="70" height="50" />
          <span>Dr.Plazma</span>
        </div>
        <nav style={{ marginTop: 10 }}>
          {menu.map(m => m.pasif ? (
            <div key={m.etiket} className="yan-link" style={{ opacity: .45, cursor: 'default' }} title="Yakında">
              <span className="yan-ikon">{m.ikon}</span>{m.etiket}
              <span style={{ marginLeft: 'auto', fontSize: 10 }}>yakında</span>
            </div>
          ) : (
            <NavLink key={m.etiket} to={m.yol} end={m.bitti} onClick={menuTikla}
                     className={({ isActive }) => 'yan-link' + (isActive ? ' aktif' : '')}>
              <span className="yan-ikon">{m.ikon}</span>{m.etiket}
            </NavLink>
          ))}
        </nav>
      </aside>

      <div className="govde">
        <header className="ust-bar">
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <button className="menu-toggle" onClick={() => setAcik(a => !a)} title="Menüyü aç/kapat" aria-label="Menü">
              ☰
            </button>
            <div className="ust-baslik">{kurumAdi}</div>
          </div>
          <div className="ust-kullanici">
            <div style={{ textAlign: 'right' }}>
              <div style={{ fontSize: 13.5, fontWeight: 700 }}>{adSoyad}</div>
              <div style={{ fontSize: 11.5, color: 'var(--metin-soluk)' }}>{kullanici.grup || 'Personel'}</div>
            </div>
            <div className="avatar">{basharf}</div>
            <button className="cikis-btn" onClick={cikis}>Çıkış</button>
          </div>
        </header>

        <main className="icerik">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
